import { gql } from '@apollo/client';

export const CREATE_SURROUNDING_INFORMATION_LOCALIZATION_MUTATION = gql`
  mutation CreateSurroundingInformationLocalization($data: updateSurroundingInformationInput!) {
    createSurroundingInformationLocalization(input: $data) {
      id
    }
  }
`;
